var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Checkbox, DropdownDivider, DropdownHeader, Grid, Icon, Input, Select } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { miValidatedIcon } from "../kit/rna-cish/ProbeSetForm";
import { debounce } from "../kit/rna-cish/ProKitForm";
import { Accession, ProbeSetFamily } from "../kit/rna-cish/RnaCatalog";
import { getWithAuthn } from "../RequestHelpers";
import { validationTypes } from "./ProbeLotTablePage";
var CreateNewColumnPurifiedProbeLotModal = /** @class */ (function (_super) {
    __extends(CreateNewColumnPurifiedProbeLotModal, _super);
    function CreateNewColumnPurifiedProbeLotModal(props) {
        var _this = _super.call(this, props) || this;
        _this.targetOptions = function () {
            var exactMatchFamilies = _this.state.currentProbeSetFamiliesList.filter(function (psf) {
                return _this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.state.geneSymbol);
            });
            var synonymFamilies = _this.state.currentProbeSetFamiliesList.filter(function (psf) {
                return _this.searchQueryIsSynonymForProbeSetFamily(psf, _this.state.geneSymbol);
            });
            var otherProbeSetFamilies = _this.state.currentProbeSetFamiliesList.filter(function (psf) {
                return !_this.searchQueryIsSynonymForProbeSetFamily(psf, _this.state.geneSymbol) &&
                    !_this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.state.geneSymbol);
            });
            var options = [];
            options = options.concat((exactMatchFamilies.length > 0 || synonymFamilies.length > 0) ? [
                React.createElement(DropdownHeader, { key: 'recommended-header', content: 'Recommended' }),
                React.createElement(DropdownDivider, { key: 'recommended-divider' })
            ] : []).concat(exactMatchFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null,
                        "(",
                        f.description,
                        ")"));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat(synonymFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null,
                        "(",
                        f.description,
                        ")"));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat((otherProbeSetFamilies.length !== 0 && _this.state.geneSymbol !== '') ? [
                React.createElement(DropdownHeader, { key: 'other-header', content: "Other Results for " + _this.state.geneSymbol }),
                React.createElement(DropdownDivider, { key: 'other-divider' })
            ]
                : []).concat(otherProbeSetFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null,
                        "(",
                        f.description,
                        ")"));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            }));
            return options;
        };
        _this.probeSetFamilyHasMIValidatedEntry = function (f) {
            var _a, _b;
            if (((_a = _this.state.selectedProbeSetFamily) === null || _a === void 0 ? void 0 : _a.id) === f.id) {
                return (_b = _this.state.selectedProbeSetFamily) === null || _b === void 0 ? void 0 : _b.variants.some(function (v) { return v.validated === 'MI_VALIDATED'; });
            }
            else {
                return false;
            }
        };
        _this.searchQueryIsSynonymForProbeSetFamily = function (f, searchQuery) {
            return !!f.synonyms.find(function (s) { return s.toLowerCase() === searchQuery.toLowerCase(); });
        };
        _this.searchQueryIsExactMatchToProbeSetFamily = function (f, searchQuery) {
            return f.geneSymbol.toLowerCase() === searchQuery.toLowerCase();
        };
        _this.onProbeSetFamilyChange = function (event, data) {
            getWithAuthn("/admin/rna/search/probeSetFamilyId/" + encodeURIComponent(data.value))
                .then(function (resp) {
                if (resp.status === 200) {
                    return resp.json();
                }
                else {
                    return undefined;
                }
            })
                .then(function (jsonFamily) {
                if (jsonFamily !== undefined && jsonFamily.psf != null) {
                    var family = new ProbeSetFamily(jsonFamily.psf.id, jsonFamily.psf.geneSymbol, jsonFamily.psf.description, jsonFamily.psf.geneType, jsonFamily.psf.accessions, jsonFamily.psf.synonyms, function (psf) {
                        return jsonFamily.psf.variants.map(function (v) {
                            return {
                                id: v.id,
                                organism: _this.props.organism,
                                probeSetFamily: psf,
                                name: v.name,
                                designNumber: v.designNumber,
                                targetMrnaSeq: v.targetMrnaSeq,
                                accession: v.accession ? new Accession(v.accession.id, v.accession.transcriptAccession, v.accession.accessionType, v.accession.transcriptLength, v.accession.transcriptName) : undefined,
                                probeSetSize: v.probeSetSize,
                                validated: v.validated,
                                dcvScore: v.dcvScore
                            };
                        });
                    }, function (psf) {
                        return {
                            id: jsonFamily.psf.defaultVariant.id,
                            organism: _this.props.organism,
                            probeSetFamily: psf,
                            name: jsonFamily.psf.defaultVariant.name,
                            designNumber: jsonFamily.psf.defaultVariant.designNumber,
                            targetMrnaSeq: jsonFamily.psf.defaultVariant.targetMrnaSeq,
                            accession: jsonFamily.psf.defaultVariant.accession ? new Accession(jsonFamily.psf.defaultVariant.accession.id, jsonFamily.psf.defaultVariant.accession.transcriptAccession, jsonFamily.psf.defaultVariant.accession.accessionType, jsonFamily.psf.defaultVariant.accession.transcriptLength, jsonFamily.psf.defaultVariant.accession.transcriptName) : undefined,
                            probeSetSize: jsonFamily.psf.defaultVariant.probeSetSize,
                            validated: jsonFamily.psf.defaultVariant.validated,
                            dcvScore: jsonFamily.psf.defaultVariant.dcvScore
                        };
                    });
                    _this.setState({
                        selectedProbeSetFamily: family,
                        variantName: '',
                        amplifierId: ''
                    });
                }
                else {
                    _this.setState({
                        selectedProbeSetFamily: undefined,
                        currentProbeSetFamiliesList: [],
                        variantName: '',
                        amplifierId: ''
                    });
                }
            });
        };
        _this.onSearch = function (options, _) {
            return options;
        };
        _this.onSearchQueryChange = function (event, data) {
            var path = "";
            if (_this.state.selectedOrganism === undefined || data.searchQuery.length === 0) {
                _this.setState({
                    currentProbeSetFamiliesList: [],
                    selectedProbeSetFamily: undefined
                });
                return;
            }
            path = "/admin/rna/search/id/" +
                (encodeURIComponent(_this.state.selectedOrganism.id) + "/targetGene/") +
                ("" + encodeURIComponent(data.searchQuery));
            getWithAuthn(path)
                .then(function (resp) {
                if (resp.status === 200) {
                    return resp.json();
                }
                else {
                    return undefined;
                }
            })
                .then(function (resp) {
                if (resp !== undefined) {
                    _this.setState({
                        geneSymbol: data.searchQuery,
                        currentProbeSetFamiliesList: resp.probeSetFamilyResults,
                        selectedProbeSetFamily: undefined
                    });
                }
                else {
                    _this.setState({
                        selectedProbeSetFamily: undefined
                    });
                }
            });
        };
        _this.onLotNumberChange = function (event, data) {
            var str = data.value;
            _this.setState({ lotNumber: str });
        };
        _this.onStatusChange = function (event, data) {
            var str = data.value;
            _this.setState({ status: str });
        };
        _this.onValidationChange = function (event, data) {
            var str = data.value;
            _this.setState({ validation: str });
        };
        _this.onOrderedDateChange = function (event, data) {
            var str = data.value;
            _this.setState({ orderedDate: str });
        };
        _this.onReceivedDateChange = function (event, data) {
            var str = data.value;
            _this.setState({ receivedDate: str });
        };
        _this.onPurifiedDateChange = function (event, data) {
            var str = data.value;
            _this.setState({ purifiedDate: str });
        };
        _this.onOrganismIdChange = function (event, data) {
            var num = data.value;
            _this.setState({
                organismId: num,
                selectedOrganism: _this.props.catalog.rnaCatalog.probeSet.catalog.organisms.find(function (o) { return o.id === data.value; }),
                selectedProbeSetFamily: undefined,
                currentProbeSetFamiliesList: [],
                variantName: '',
                amplifierId: ''
            });
        };
        _this.onCustomOrganismNameChange = function (event, data) {
            var str = data.value;
            _this.setState({ customOrganismName: str });
        };
        _this.onAmplifierChange = function (event, data) {
            var val = data.value;
            if (typeof (val) !== 'string') {
                throw new Error("Unexpected value " + val);
            }
            _this.setState({
                amplifierId: val
            });
        };
        _this.onVariantNameChange = function (event, data) {
            var str = data.value;
            _this.setState({
                variantName: str
            });
        };
        _this.onCustomTargetNameChange = function (event, data) {
            var str = data.value;
            _this.setState({ customTargetName: str });
        };
        _this.onCustomTargetAccessionChange = function (event, data) {
            var str = data.value;
            _this.setState({ customTargetAccession: str });
        };
        _this.onCustomTargetMrnaSeqChange = function (event, data) {
            var str = data.value;
            _this.setState({ customTargetMrnaSeq: str });
        };
        _this.onCustomVariantNameChange = function (event, data) {
            var str = data.value;
            _this.setState({ customVariantName: str });
        };
        _this.onCustomProbeSetSizeChange = function (event, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ customProbeSetSize: num });
        };
        _this.onPurifiedVolumeChange = function (event, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ purifiedVolume: num });
        };
        _this.onA260OfDilutedSampleChange = function (event, data) {
            var str = data.value;
            if (!str || str.match(/^\d{1,}(\.\d{0,4})?$/)) {
                _this.setState({ a260OfDilutedSample: str });
            }
        };
        _this.onCoefChange = function (event, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ coef: num });
        };
        _this.onCalculateYieldChange = function (_) {
            _this.setState(function (oldState) {
                return {
                    calculateYield: !oldState.calculateYield
                };
            });
        };
        _this.submit = function () {
            var variant;
            if (_this.props.probeLotType === 'Catalog' && _this.state.selectedOrganism !== undefined && _this.state.selectedProbeSetFamily !== undefined) {
                variant = _this.state.selectedProbeSetFamily.variants.find(function (v) {
                    return v.probeSetFamily.id === _this.state.selectedProbeSetFamily.id
                        && v.name === _this.state.variantName;
                });
            }
            _this.props.postRequest("/rna/probe-lot/create/column-purified", {
                lotNumber: _this.state.lotNumber,
                orderedDate: _this.state.orderedDate,
                receivedDate: _this.state.receivedDate,
                purifiedDate: _this.state.purifiedDate,
                validation: _this.state.validation,
                purifiedVolume: _this.state.purifiedVolume,
                a260OfDilutedSample: isNaN(parseFloat(_this.state.a260OfDilutedSample)) ? null : parseFloat(_this.state.a260OfDilutedSample),
                coef: _this.state.coef,
                calculateYield: _this.state.calculateYield,
                probeLotType: _this.props.probeLotType,
                variantId: variant === null || variant === void 0 ? void 0 : variant.id,
                organismId: _this.props.probeLotType === 'CatalogOrgCustom' ? _this.state.organismId : null,
                organismOtherName: _this.props.probeLotType === 'Custom' ? _this.state.customOrganismName : '',
                customTargetName: (_this.props.probeLotType === 'CatalogOrgCustom' || _this.props.probeLotType === 'Custom') ? _this.state.customTargetName : '',
                customTargetAccession: (_this.props.probeLotType === 'CatalogOrgCustom' || _this.props.probeLotType === 'Custom') ? _this.state.customTargetAccession : '',
                customTargetMrnaSeq: (_this.props.probeLotType === 'CatalogOrgCustom' || _this.props.probeLotType === 'Custom') ? _this.state.customTargetMrnaSeq : '',
                hcrAmplifier: _this.state.amplifierId,
                customProbeSetSize: (_this.props.probeLotType === 'CatalogOrgCustom' || _this.props.probeLotType === 'Custom') ? _this.state.customProbeSetSize : 0,
                customVariantName: (_this.props.probeLotType === 'CatalogOrgCustom' || _this.props.probeLotType === 'Custom') ? _this.state.customVariantName : '',
                status: _this.state.status
            });
        };
        _this.state = {
            lotNumber: _this.props.nextProbeLotNumber,
            status: '',
            orderedDate: undefined,
            receivedDate: undefined,
            purifiedDate: undefined,
            validation: validationTypes.find(function (v) { return v === 'NOT_VALIDATED'; }),
            organismId: _this.props.organism ? _this.props.organism.id : undefined,
            customOrganismName: _this.props.customOrganismName ? _this.props.customOrganismName : '',
            geneSymbol: _this.props.probeSetFamily ? _this.props.probeSetFamily.geneSymbol : '',
            customTargetName: _this.props.customTargetName ? _this.props.customTargetName : '',
            customTargetAccession: _this.props.customTargetAccession ? _this.props.customTargetAccession : '',
            customTargetMrnaSeq: _this.props.customTargetMrnaSeq ? _this.props.customTargetMrnaSeq : '',
            customProbeSetSize: _this.props.customProbeSetSize ? _this.props.customProbeSetSize : 0,
            customVariantName: '',
            amplifierId: _this.props.amplifierId ? _this.props.amplifierId : '',
            variantName: _this.props.variantName ? _this.props.variantName : undefined,
            purifiedVolume: undefined,
            a260OfDilutedSample: undefined,
            coef: undefined,
            calculateYield: false,
            currentProbeSetFamiliesList: _this.props.probeSetFamily ? [{ id: _this.props.probeSetFamily.id, geneSymbol: _this.props.probeSetFamily.geneSymbol,
                    description: _this.props.probeSetFamily.description, synonyms: _this.props.probeSetFamily.synonyms }] : [],
            selectedProbeSetFamily: _this.props.probeSetFamily ? _this.props.probeSetFamily : undefined,
            selectedOrganism: _this.props.organism ? _this.props.organism : undefined
        };
        return _this;
    }
    CreateNewColumnPurifiedProbeLotModal.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.status === 'ORDERED' && prevState.status !== 'ORDERED') {
            this.setState({ orderedDate: prevState.orderedDate || new Date().toISOString().split('T')[0] });
        }
        if (this.state.status === 'RECEIVED' && prevState.status !== 'RECEIVED') {
            this.setState({
                receivedDate: prevState.receivedDate || new Date().toISOString().split('T')[0],
                coef: prevState.coef
            });
        }
        if (this.state.status === 'PROBES_PURIFIED' && prevState.status !== 'PROBES_PURIFIED') {
            this.setState({
                purifiedDate: prevState.purifiedDate || new Date().toISOString().split('T')[0],
                a260OfDilutedSample: prevState.a260OfDilutedSample
            });
        }
    };
    CreateNewColumnPurifiedProbeLotModal.prototype.render = function () {
        var catalog = this.props.catalog.rnaCatalog;
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/lotNumber', labelContent: 'Probe Lot Number' },
                React.createElement(Input, { onChange: this.onLotNumberChange, placeholder: 'OSA', type: "text", value: this.state.lotNumber })),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/status', labelContent: 'Probe Lot Status' },
                React.createElement(Select, { options: probeLotStatus.map(function (s) {
                        return {
                            text: s,
                            value: s
                        };
                    }), placeholder: 'Probe Lot Status', onChange: this.onStatusChange, value: this.state.status })),
            this.state.status === 'ORDERED' &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/orderedDate', labelContent: 'Ordered Date' },
                    React.createElement(Input, { onChange: this.onOrderedDateChange, placeholder: 'Date', type: "date", value: this.state.orderedDate })),
            this.state.status === 'RECEIVED' &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/receivedDate', labelContent: 'Received Date' },
                    React.createElement(Input, { onChange: this.onReceivedDateChange, placeholder: 'Date', type: "date", value: this.state.receivedDate })),
            this.state.status === 'PROBES_PURIFIED' &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/purifiedDate', labelContent: 'Purified Date' },
                    React.createElement(Input, { onChange: this.onPurifiedDateChange, placeholder: 'Date', type: "date", value: this.state.purifiedDate })),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/validation', labelContent: 'Validation' },
                React.createElement(Select, { options: validationTypes.map(function (v) {
                        return {
                            text: v,
                            value: v
                        };
                    }), placeholder: validationTypes[0], onChange: this.onValidationChange, value: this.state.validation })),
            (this.props.probeLotType === 'Catalog' || this.props.probeLotType === 'CatalogOrgCustom') &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/organismName', labelContent: 'Organism Name' },
                    React.createElement(Select, { options: catalog.probeSet.catalog.organisms.map(function (o) {
                            return {
                                text: o.name,
                                description: o.scientificName,
                                value: o.id
                            };
                        }), search: true, placeholder: 'Organism Name', onChange: this.onOrganismIdChange, value: this.state.organismId })),
            this.props.probeLotType === 'Custom' &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customOrganismName', labelContent: 'Custom Organism Name' },
                    React.createElement(Input, { onChange: this.onCustomOrganismNameChange, placeholder: 'Human', type: "text", value: this.state.customOrganismName })),
            this.props.probeLotType === 'Catalog' &&
                React.createElement(React.Fragment, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/geneSymbol', labelContent: 'Gene Symbol' },
                        React.createElement(Select, { spellCheck: false, disabled: this.state.organismId === undefined, noResultsMessage: 'No results found', clearable: true, placeholder: 'Gene Symbol', options: this.targetOptions(), onSearchChange: debounce(this.onSearchQueryChange, 500), search: this.onSearch, onChange: this.onProbeSetFamilyChange, value: this.state.selectedProbeSetFamily ?
                                this.state.selectedProbeSetFamily.id : "" })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/variantName', labelContent: 'Variant Name' },
                        React.createElement(Select, { options: this.state.selectedProbeSetFamily ? this.state.selectedProbeSetFamily.variants
                                .map(function (v) {
                                return {
                                    text: v.name,
                                    description: v.probeSetSize,
                                    value: v.name
                                };
                            }) : [], disabled: this.state.selectedProbeSetFamily === undefined, search: true, placeholder: 'Variant Name', onChange: this.onVariantNameChange, value: this.state.variantName }))),
            (this.props.probeLotType === 'CatalogOrgCustom' || this.props.probeLotType === 'Custom') &&
                React.createElement(React.Fragment, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customTargetName', labelContent: 'Custom Target Name' },
                        React.createElement(Input, { onChange: this.onCustomTargetNameChange, placeholder: 'Ppib', type: "text", value: this.state.customTargetName })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customTargetAccession', labelContent: 'Custom Target Accession' },
                        React.createElement(Input, { onChange: this.onCustomTargetAccessionChange, placeholder: 'Accession', type: "text", value: this.state.customTargetAccession })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customTargetMrnaSeq', labelContent: 'Custom Target Sequence' },
                        React.createElement(Input, { onChange: this.onCustomTargetMrnaSeqChange, placeholder: 'Mrna Seq', type: "text", value: this.state.customTargetMrnaSeq })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customVariantName', labelContent: 'Custom Variant Name' },
                        React.createElement(Input, { onChange: this.onCustomVariantNameChange, placeholder: 'Variant Name', type: "text", value: this.state.customVariantName })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customProbeSetSize', labelContent: 'Custom Probe Size' },
                        React.createElement(Input, { onChange: this.onCustomProbeSetSizeChange, placeholder: '20', type: "number", value: this.state.customProbeSetSize }))),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/amplifier', labelContent: 'Amplifier' },
                React.createElement(Select, { search: true, disabled: (this.state.variantName === undefined || this.state.selectedProbeSetFamily === undefined) && this.state.customTargetName.length === 0, onChange: this.onAmplifierChange, placeholder: 'Amplifier', options: this.props.catalog.rnaCatalog.goldFishAmplifier.channels.map(function (c) {
                        return {
                            text: c.hcrAmplifier.id,
                            value: c.hcrAmplifier.id
                        };
                    }), value: this.state.amplifierId })),
            (this.state.status === 'RECEIVED' || this.state.status === 'PROBES_PURIFIED') &&
                React.createElement(Grid, { columns: 2 },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/coef', labelContent: 'Average Coefficients' },
                                React.createElement(Input, { onChange: this.onCoefChange, placeholder: 0, value: this.state.coef, disabled: this.state.status === 'PROBES_PURIFIED' }))))),
            this.state.status === 'PROBES_PURIFIED' &&
                React.createElement(Grid, { columns: 2 },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/a260OfDilutedSample', labelContent: 'A260 Of Diluted Sample' },
                                React.createElement(Input, { type: 'text', onChange: this.onA260OfDilutedSampleChange, placeholder: 0, value: this.state.a260OfDilutedSample })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/purifiedVolume', labelContent: 'Purified Volume (µL)' },
                                React.createElement(Input, { onChange: this.onPurifiedVolumeChange, placeholder: 0, value: this.state.purifiedVolume })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(Checkbox, { checked: this.state.calculateYield, label: "Calculate Yield", onChange: this.onCalculateYieldChange })))),
            React.createElement(Grid, { columns: 2 },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'plus', label: 'Create New Probe Lot', labelPosition: 'left', onClick: this.submit, positive: true })))));
    };
    return CreateNewColumnPurifiedProbeLotModal;
}(React.PureComponent));
export default CreateNewColumnPurifiedProbeLotModal;
export var probeLotStatus = [
    'ORDERED',
    'RECEIVED',
    'PROBES_PURIFIED'
];
//# sourceMappingURL=CreateNewColumnPurifiedProbeLotModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/CreateNewColumnPurifiedProbeLotModal.js
// module id = 309
// module chunks = 0